import request from '@/utils/request'

export function updateChestPropCfg(data) {
  return request({
    url: 'api/v1/chest-prop/updateCfg',
    method: 'post',
    data: data
  })
}

export function getChestPropCfgList(data) {
  return request({
    url: 'api/v1/chest-prop/getCfg',
    method: 'post',
    data: data
  })
}

export function getChestPropCfgAll() {
  return request({
    url: 'api/v1/chest-prop/getAllCfg',
    method: 'post'
  })
}

